import { Button, Kind, Size } from '@thanx/uikit/button'
import { buildTranslate } from 'locales'
import React from 'react'
import { Button as BsButton, Modal } from 'react-bootstrap'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('games')

type Props = {
  triggerDelete: () => Promise<void>
  isLoading: boolean
  show: boolean
  onHide: () => void
  gameName: string
}

const GameDeleteModal: React.FC<Props> = ({
  triggerDelete,
  show,
  onHide,
  isLoading,
  gameName,
}) => {
  const [css] = useStyletron()

  const exit = () => {
    onHide()
  }

  const onDelete = async () => {
    await triggerDelete()
    onHide()
  }

  return (
    <Modal className="fs-unmask" show={show} onHide={onHide} zIndex={1000}>
      <Modal.Body>
        <div className="clearfix">
          <div className="pull-right">
            <BsButton
              onClick={onHide}
              className="btn-borderless padding-right-none"
              data-testid="close-button"
            >
              <span className="font-size-40 line-height-30 grey-60 light">
                &times;
              </span>
            </BsButton>
          </div>
        </div>

        <h6 data-testid="title">{t('deleteModal.title')}</h6>

        <div
          className="width-75 margin-bottom-huge grey-70"
          data-testid="description"
        >
          {t('deleteModal.description', { gameName })}
        </div>

        <div className="d-flex justify-content-end align-items-center ">
          <Button
            size={Size.STANDARD}
            kind={Kind.SECONDARY}
            data-testid="cancel-button"
            className={`mr-s ${css({
              borderWidth: '2px',
            })}`}
            onClick={exit}
          >
            {t('deleteModal.buttons.cancel')}
          </Button>

          <Button
            onClick={onDelete}
            kind={Kind.PRIMARY}
            size={Size.STANDARD}
            isLoading={isLoading}
            data-testid="delete-button"
          >
            {t('deleteModal.buttons.delete')}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default GameDeleteModal
